import React from 'react';

import { withTranslation, i18n as I18n } from 'utils/i18n';

import Page from 'components/page';

import FrequentlyAskedQuestions from 'components/frequentlyAskedQuestions';

const Faqs = () => {
  return (
    <Page
      title={I18n.t('headers.faq_page.title')}
      description={I18n.t('headers.faq_page.description')}
    >
      <div className="faq">
        <h1>{I18n.t('faq.title')}</h1>

        <div className="faq__intro" id="faqIntro">
          <p>{I18n.t('faq.text')}</p>

          <ul>
            <li>
              {I18n.t('faq.see_here_for_additional')}{' '}
              <a
                href="https://www.property.nhs.uk/getting-started-with-nhs-open-space?utm_source=website&utm_campaign=faqpage"
                target="_blank"
                rel="noreferrer"
              >
                {I18n.t('faq.getting_started_with_nhs_openspace')}
              </a>
            </li>

            <li>
              {I18n.t('faq.view_and_download')}{' '}
              <a
                href="https://www.property.nhs.uk/news/news/nhs-open-space-training-resources/"
                target="_blank"
                rel="noreferrer"
              >
                {I18n.t('faq.guides_text')}
              </a>
            </li>
          </ul>

          <h4>{I18n.t('faq.help_topics')}</h4>
          <ol>
            <li>
              <a href="#howToUse">{I18n.t('faq.topics.how_to_use.title')}</a>
            </li>
            <li>
              <a href="#basics">{I18n.t('faq.topics.basics.title')}</a>
            </li>
            <li>
              <a href="#gettingStarted">
                {I18n.t('faq.topics.getting_started.title')}
              </a>
            </li>
            <li>
              <a href="#setupPayments">
                {I18n.t('faq.topics.setup_payments.title')}
              </a>
            </li>
            <li>
              <a href="#bookingsCancellations">
                {I18n.t('faq.topics.bookings_cancellations.title')}
              </a>
            </li>
            <li>
              <a href="#usingRoomsOnSite">
                {I18n.t('faq.topics.using_room_on_site.title')}
              </a>
            </li>
          </ol>
        </div>
        <FrequentlyAskedQuestions />
      </div>
    </Page>
  );
};

export default withTranslation('common')(Faqs);
